<div class="op-alert" role="alert">
	<div class="op-icon-align-body-2" [ngClass]="class">
		<mat-icon [svgIcon]="icon"></mat-icon>
		<ng-content></ng-content>
	</div>
</div>
